let prefix = '/api/sap/customer-invoices-report';


function getIDataByInvoice(docNum){
    return window.axios.get(prefix+'/getIDataByInvoice/'+docNum);
}
export default {
    getIDataByInvoice
}